import ChatPanel from '@/components/ChatPanel';

export default function TanyaAIPage() {
  return (
    <div className="flex flex-col overflow-hidden" style={{ height: 'calc(100vh - 360px)' }}>
      <div className="shrink-0 mb-4 pb-2 border-b-2 border-ink flex items-baseline gap-3 flex-wrap">
        <span className="text-brass text-xl self-center">✦</span>
        <h1 className="font-display font-bold text-[22px] leading-tight tracking-tight">Tanya AI</h1>
        <span className="font-mono text-[10px] uppercase tracking-widest text-ink-3">— Asisten Umum · Lintas BAP</span>
        <span className="ml-auto font-mono text-[10px] uppercase tracking-wider text-ink-3">RAG · multi-turn · citation</span>
      </div>

      <div className="flex-1 min-h-0">
        <ChatPanel
          docId={null}
          title="Asisten Umum"
          subtitle="RAG · lintas BAP · multi-turn · citation hal."
          sidebarWidth={260}
          minHeight="100%"
        />
      </div>
    </div>
  );
}
